module.exports = __webpack_public_path__ + "static/media/ios-permission-step-1.a290cb0a.png";